import { Classes, Image } from '@/imports-files/components/logo';
// TODO: Import from one file
// import CandidlyLogo from 'public/images/logo/Full-logo-default-linen-text.png';
import CandidlyLogo from 'public/images/logo/Bluelogo.png'

function Logo(props){
    return (
                <div className={`MainNav__Logo ${Classes.MainNav__Logo}`} style={props.style}>
                  <Image className={Classes.MainNav__LogoImg} src={CandidlyLogo} alt="Heartpace-Logo"></Image>
                </div>
            )
}

export default Logo;
